import React from "react";
import { useTranslation } from "react-i18next";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SEO from "./SEO";

export default function TermsOfTravel() {
  const { t } = useTranslation();

  return (
    <div className="app">
      <SEO 
        title={`${t("termsOfTravel.title")} - TraveLina`}
        description="Opći uvjeti putovanja i poslovanja TraveLina putničke agencije."
        keywords="uvjeti putovanja, opći uvjeti, TraveLina"
      />
      <Navbar />
      <main>
        <section className="section" style={{ paddingTop: "6rem" }}>
          <div className="container">
            <article className="terms-of-travel">
              <h1 style={{ marginBottom: "2rem", color: "#f97316", fontSize: "2rem" }}>
                {t("termsOfTravel.title")}
              </h1>

              <div
                style={{
                  padding: "2rem",
                  background: "#fafafa",
                  borderRadius: "0.75rem",
                  border: "1px solid rgba(0, 0, 0, 0.08)",
                  fontSize: "0.95rem",
                  lineHeight: "1.8",
                  color: "#111827",
                  whiteSpace: "pre-wrap",
                }}
              >
                {t("termsOfTravel.content")}
              </div>
            </article>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

